<template>
    <span v-if="mostrarBtn">
        <span class="text-primary">
            <i
                class="fa fa-file-text fa-lg icon-button"
                title="Comprovantes"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" size="sm">
            <div slot="modal-title">Comprovantes NF {{ pagamento.documento }}</div>
            <b-row>
                <b-col sm="12">
                    <b-list-group>
                        <b-list-group-item
                            button
                            v-if="pagamento.irrf > 0"
                            @click="obterComprovante(0)"
                            >DARF</b-list-group-item
                        >
                        <b-list-group-item
                            button
                            v-if="pagamento.inss > 0"
                            @click="obterComprovante(1)"
                            >GPS</b-list-group-item
                        >
                    </b-list-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
// import { entregaStatus } from './EntregaStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            default: () => {}
        },

        fornecedorId: {
            type: String,
            default: () => null
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        obterComprovante(tipo) {
            this.$store.dispatch('addRequest')
            let reciboDto = {
                fornecedorId: this.fornecedorId,
                id: this.pagamento.idMov,
                comprovante: tipo
            }
            this.dataServico.obterComprovante(reciboDto).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            `Erro ao realizar download do comprovante. Por favor, tente novamente em alguns minutos.`,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(
                            response,
                            `Comprovante_${tipo == 0 ? 'DARF' : 'GPS'}_${
                                this.pagamento.documento
                            }.pdf`
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        mostrarBtn() {
            return this.pagamento.irrf > 0 || this.pagamento.inss > 0
        }
    }
}
</script>
